import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { c } from '@debbie/cortex/dist';
import { selectTransactionImportById } from '@debbie/cortex/dist/transaction-accounts/selectors';
import File from '../File';
const TransactionImportPreview = (props) => {
    const transactionImport = useSelector((s) => selectTransactionImportById(s, props.transactionImportId));
    useEffect(() => {
        if (!transactionImport) {
            c.transactionAccounts.getImportById(props.transactionImportId);
        }
    }, [props.transactionImportId]);
    return (React.createElement(React.Fragment, null, transactionImport && (React.createElement(File, { file: {
            fileName: transactionImport.fileName,
            contentType: transactionImport.fileContentType,
            fileId: transactionImport.fileId,
        } }))));
};
export default TransactionImportPreview;
//# sourceMappingURL=TransactionImportPreview.js.map